import {
    createSelfNomination,
} from "./api";
import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { invalidateAllQueries } from "utils/utils";
import { useSelector } from "react-redux";
import { selectUser } from "store";

export const useCreateSelfNomination = ({ onSuccess: customOnSuccess }) => {
    const user = useSelector(selectUser)
    return useMutation({
        mutationFn: async ({ quadId, employeeIds }) => {
            const mutations = employeeIds.map((employeeId) =>
                createSelfNomination({
                    quadrimester: quadId,
                    reviewer: employeeId,
                    reviewee: user.id,
                    self_nominated: true,
                    status: "pending",
                })
            );
            const response = await Promise.all(mutations);
            return response;
        },
        onSuccess: () => {
            toast.success("Reviewer nominated successfully");
            invalidateAllQueries();
            customOnSuccess();
        },
        onError: (error) => {
            toast.error(error.message);
            console.error(error.message);
        },
    });
};